export default __webpack_public_path__ + "static/media/facebook.09acd56d.svg";